// tslint:disable:max-line-length

import React from 'react';

export const DatatypePercentage = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M1,5.77c0-2.54,1-3.84,2.75-3.84s2.74,1.3,2.74,3.84-1,3.88-2.74,3.88S1,8.35,1,5.77Zm3.55,0c0-1.52-.19-2.14-.8-2.14S3,4.25,3,5.77,3.17,8,3.77,8,4.57,7.33,4.57,5.77ZM10,2.08h2L6,13.92H4Zm-.53,8.11c0-2.56,1-3.86,2.75-3.86S15,7.63,15,10.19s-1,3.87-2.74,3.87S9.49,12.77,9.49,10.19Zm3.55,0c0-1.52-.19-2.14-.8-2.14s-.81.62-.81,2.14.2,2.19.81,2.19S13,11.73,13,10.19Z" />
    </svg>
  );
};
